module.exports = __webpack_public_path__ + "static/img/挂锁图纸.fa90075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/guaLock/挂锁图纸.jpg
// module id = FwTl
// module chunks = 0